export const equipmentIdOf = equipment =>
  equipment?.TerminalID || equipment?.GatewayID || equipment?.id || "";

export const equipmentQuantity = value => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : 1;
};

const numberOrZero = value => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const withEquipmentQuantity = (equipment, quantity) => {
  const normalizedQuantity = equipmentQuantity(quantity);
  const unitPrice = numberOrZero(equipment?.price);
  const currentPrices = Array.isArray(equipment?.prices) ? equipment.prices : [];
  const prices = Array.from({ length: normalizedQuantity }, (_, index) =>
    index < currentPrices.length ? numberOrZero(currentPrices[index]) : unitPrice
  );

  return {
    ...equipment,
    quantity: normalizedQuantity,
    prices
  };
};

export const buildLinkEquipment = (
  inventoryEquipment,
  processor,
  quantity = 1,
  currentEquipment = {}
) => withEquipmentQuantity({
  ...inventoryEquipment,
  price: numberOrZero(currentEquipment.price),
  prices: currentEquipment.prices || [],
  softwareFee: numberOrZero(currentEquipment.softwareFee),
  hardwareDescription: currentEquipment.hardwareDescription || "",
  feeDescription: currentEquipment.feeDescription || "",
  processor
}, quantity);

export const toPaysafeEquipment = equipment => {
  if (!Array.isArray(equipment)) {
    return [];
  }

  return equipment.reduce((result, item) => {
    const equipmentId = equipmentIdOf(item);
    const processorId = item?.processor?.ProcessorID;

    if (!equipmentId || !processorId) {
      throw new Error("Equipment and processor are required before submission.");
    }

    const equipmentType = item.type || (item.GatewayID ? "G" : "TM");
    const quantity = equipmentQuantity(item.quantity);

    for (let index = 0; index < quantity; index += 1) {
      result.push({
        EquipmentTypeID: equipmentType,
        EquipmentID: equipmentId,
        ProcessorID: processorId,
        FieldValues: [],
        Peripherials: []
      });
    }

    return result;
  }, []);
};
